export default __webpack_public_path__ + "static/media/bg-pick-right.9d2e898a.png";